import React, { useEffect } from "react";
import { Form, Button, Spin, Select } from "antd";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { doGetAllRoutePlans } from "../../../modules/routePlan/stores/thunk";
import { selectAllRoutePlans } from "../../../modules/routePlan/stores/slice";
import "./BulkDelete.scss";

import { DATE_FORMAT_FRONTEND } from "../../../constants";
import { getTranslation } from "../../../utils/helper";

const BulkAddToRoutePlanForm = ({ form, isFetching, handleSubmit, handleCancel }) => {
  const user = useSelector(state => state.auth.user);
  const setting = useSelector(state => state.setting.setting) || user?.company;

  const dispatch = useDispatch();
  const routePlans = selectAllRoutePlans(useSelector(state => state));

  useEffect(() => {
    dispatch(doGetAllRoutePlans({}));
  }, []);

  return (
    <Spin spinning={isFetching}>
      <div className="BulkAddToRoutePlanForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormHeader">
            <div className="left">{getTranslation(setting, "Orders", "Add to Existing Route Plan")}</div>
          </div>
          <div className="FormContent">
            <Form.Item
              label={getTranslation(setting, "Orders", "Select Route Plan")}
              name="routePlanId"
              rules={[{ required: true, message: "Required" }]}>
              <Select size="large" placeholder={getTranslation(setting, "Orders", "Select Route Plan")}>
                {routePlans
                  .filter(r => r.type === setting?.routePlanType)
                  .map(item => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name} - {moment(item.deliveryDate).utc().format(DATE_FORMAT_FRONTEND)}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                {getTranslation(setting, "Common", "Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {getTranslation(setting, "Common", "Confirm")}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BulkAddToRoutePlanForm;
